import { getTradingBattleContract } from 'utils/contractHelpers'

const tradingBattleContract = getTradingBattleContract()

export const fetchCompetitionStatus = async () => {
  const competitionStatus = await tradingBattleContract.currentStatus()
  return competitionStatus
}
